import React, { useContext } from 'react';
import { LeagueContext } from '../contexts/LeagueContext';

const LeagueSelector = ({ onOpenLeagueSettings }) => {
  const { currentLeague, userLeagues, switchLeague, loading, isLeagueAdmin } = useContext(LeagueContext);

  if (loading) {
    return <div className="text-sm">Loading leagues...</div>;
  }

  if (userLeagues.length <= 1) {
    return currentLeague ? (
      <div className="flex items-center gap-2">
        <div className="text-sm font-semibold text-primary bg-primary/10 px-3 py-1 rounded-md">
          {currentLeague.name}
        </div>
        {isLeagueAdmin && (
          <button
            onClick={() => onOpenLeagueSettings && onOpenLeagueSettings()}
            className="btn btn-xs btn-ghost text-yellow-600 hover:bg-yellow-600/10"
            title="League Settings"
          >
            ⚙️
          </button>
        )}
      </div>
    ) : null;
  }

  return (
    <div className="dropdown dropdown-end">
      <div tabIndex={0} role="button" className="btn btn-ghost btn-sm">
        <span className="text-sm font-medium">
          {currentLeague ? currentLeague.name : 'Select League'}
        </span>
        <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </div>
      <ul tabIndex={0} className="dropdown-content z-[1] menu p-2 shadow bg-base-100 rounded-box w-52">
        {userLeagues.map((league) => (
          <li key={league.id}>
            <button
              onClick={() => switchLeague(league.id)}
              className={`text-left ${currentLeague?.id === league.id ? 'active' : ''}`}
            >
              <div>
                <div className="font-medium">{league.name}</div>
                <div className="text-xs text-base-content/60">
                  {league.memberCount} members
                </div>
              </div>
            </button>
          </li>
        ))}
        
        {/* League Settings option for admins */}
        {isLeagueAdmin && currentLeague && (
          <>
            <div className="divider my-1"></div>
            <li>
              <button
                onClick={() => onOpenLeagueSettings && onOpenLeagueSettings()}
                className="text-yellow-600 hover:bg-yellow-600/10"
              >
                <span>⚙️</span>
                <span>League Settings</span>
              </button>
            </li>
          </>
        )}
      </ul>
    </div>
  );
};

export default LeagueSelector;